import { type Environment } from 'react-relay';
import { nftPublicProfileEditMutation } from '../profileEdit/nftPublicProfileEditMutation';
import {
    type nftPublicProfileEditMutation$data as MutationResponse,
    type PublicProfileEditInput,
} from '../profileEdit/__generated__/nftPublicProfileEditMutation.graphql';

type Input = Omit<PublicProfileEditInput, 'clientMutationId' | 'avatarImageId' | 'heroImageId'> & {
    avatarImageId?: string | number | null;
    heroImageId?: string | number | null;
};

export const saveProfile = async ({
    input,
    environment,
}: {
    input: Input;
    environment: Environment;
}): Promise<MutationResponse['publicProfileEdit']> => {
    const {
        userId,
        username,
        displayName,
        bio,
        avatarImageId,
        heroImageId,
        facebookLink,
        instagramLink,
        discordLink,
        twitterLink,
        wikipediaLink,
        webLink,
    } = input;

    const { publicProfileEdit } = await nftPublicProfileEditMutation({
        input: {
            userId,
            username,
            displayName,
            bio,
            facebookLink,
            instagramLink,
            discordLink,
            twitterLink,
            wikipediaLink,
            webLink,
            avatarImageId: avatarImageId?.toString(),
            heroImageId: heroImageId?.toString(),
            status: 'ACTIVE',
        },
        environment,
    });

    return publicProfileEdit;
};
